<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm0 20A9 9 0 016 7.38L18.62 20A9 9 0 0113 22zm7-3.38L7.38 6A9 9 0 0120 18.62z"/>
</template>
